import React, { useEffect, useRef, useState } from "react";
import { Music2, Pause } from "lucide-react";
import { motion } from "framer-motion";

const AUDIO_URL = "/audio/wedding-song.mp3";

export default function AudioPlayer({ shouldAutoplay }) {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    if (shouldAutoplay && audioRef.current) {
      audioRef.current.volume = 0.4;
      audioRef.current.play()
        .then(() => setPlaying(true))
        .catch(() => setPlaying(false));
    }
  }, [shouldAutoplay]);

  const toggle = () => {
    if (!audioRef.current) return;
    if (playing) {
      audioRef.current.pause();
      setPlaying(false);
    } else {
      audioRef.current.volume = 0.4;
      audioRef.current.play().then(() => setPlaying(true)).catch(() => {});
    }
  };

  return (
    <>
      <audio ref={audioRef} src={AUDIO_URL} loop preload="auto" />
      <motion.button
        data-testid="audio-player-toggle"
        onClick={toggle}
        aria-label={playing ? "Jeda musik" : "Putar musik"}
        className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-ivory/80 backdrop-blur-md flex items-center justify-center audio-glow"
        initial={{ opacity: 0, scale: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 1.2, duration: 0.5 }}
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.92 }}
      >
        <motion.div
          animate={playing ? { rotate: 360 } : { rotate: 0 }}
          transition={playing ? { repeat: Infinity, duration: 6, ease: "linear" } : { duration: 0.4 }}
        >
          {playing ? <Pause size={20} className="text-gold-dark" /> : <Music2 size={20} className="text-gold-dark" />}
        </motion.div>
      </motion.button>
    </>
  );
}
